
import Vue from 'vue';
export default {
    scrollToTop: true,
    head() {
        return {
            title: this.title,
            meta: [{
                hid: 'og:title',
                property: 'og:title',
                content: this.title
            },
            {
                hid: 'twitter:title',
                property: 'twitter:title',
                content: this.title
            },
            {
            hid: 'description',
            name: 'description',
            content:'Explore the full details of Ashtavinayak "Shree Varadvinayak Ganpati Temple Mahad" in English.'
          },
          {
            hid: 'og:description',
            property: 'og:description',
            content:'Explore the full details of Ashtavinayak "Shree Varadvinayak Ganpati Temple Mahad" in English.'
          },
          {
            hid: 'twitter:description',
            property: 'twitter:description',
            content:'Shree Varadvinayak Temple, Varadvinayak Ganpati Mahad, Ashtavinayak Ganpati Mahad, Varadvinayak Vinayak Temple, Ashtavinayak Yatra Mahad, Mahad Ganpati Temple, Varadvinayak Ganesh Maharashtra, Ashtavinayak Pilgrimage Mahad, Varadvinayak Temple History, varad vinayak mahad ganpati, mahad ganpati temple distance'
          },
          {
            hid: 'keywords',
            name: 'keywords',
            content:'Shree Varadvinayak Temple, Varadvinayak Ganpati Mahad, Ashtavinayak Ganpati Mahad, Varadvinayak Vinayak Temple, Ashtavinayak Yatra Mahad, Mahad Ganpati Temple, Varadvinayak Ganesh Maharashtra, Ashtavinayak Pilgrimage Mahad, Ganpati Temple Mahad Raigad, Varadvinayak Temple History, varad vinayak mahad ganpati, mahad ganpati temple distance, varad vinayak mahad temple timings, varad vinayak temple mahad khopoli, mahad ganpati temple location, mahad ganpati ashtavinayak' 
          },
          {
            hid: 'image',
            property: 'image',
            content: this.$config.siteUrl + '/img/ashtavinayak/varadvinayak.webp'
          },
          {
            hid: 'og:image',
            property: 'og:image',
            content: this.$config.siteUrl + '/img/ashtavinayak/varadvinayak.webp'
          },
        ],
        }
    },

    components: {
    },
    data() {
        return {
            title: 'Shree Varadvinayak Ganpati Temple Mahad | Ashtavinayak - श्री वरदविनायक मंदिर महड(अष्टविनायक)',
            langauageMarathi: true
        }
    },
    layout: 'detailsPage-withoutFooter',

    jsonld() {
    return {
      '@context': 'https://schema.org',
      "@graph": [{
        "@type": "Article",
        "mainEntityOfPage": {
          "@type": "WebPage",
          "@id": "https://goa.app/ashtavinayak/varadvinayak"
        },
        "headline": "Shree Varadvinayak Ganpati Temple Mahad - श्री वरदविनायक मंदिर महड(अष्टविनायक)",
        "name" : "Shree Varadvinayak Ganpati Temple Mahad - Ashtavinayak",
        "description": "Explore the full details of Ashtavinayak 'Shree Varadvinayak Ganpati Temple Mahad' in English.",
        "image": this.$config.siteUrl + '/img/ashtavinayak/varadvinayak.webp',  
        "author": {
          "@type": "Organization",
          "name": "Goa App",
          "url": "https://goa.app"
        },  
        "publisher": {
          "@type": "Organization",
          "name": "Goa App",
          "logo": {
            "@type": "ImageObject",
            "url": "https://goa.app/android-chrome-384x384.png"
          }
        },
        "datePublished": "2024-10-10T08:00:00+08:00",
        "dateModified": "2024-10-10T09:20:00+08:00"
      },]}
    },


    computed: {

    },
    methods: {
        changeLanguage: function () {
            this.langauageMarathi = !this.langauageMarathi
        }
    }

}
